import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { InMemoryCacheService } from 'src/app/common';

@Component({
    selector: 'gig-organization-subscription-inactive',
    standalone: true,
    imports: [CommonModule, ButtonModule, RouterModule],
    templateUrl: './organization-subscription-inactive.component.html',
    styleUrls: ['./organization-subscription-inactive.component.scss']
})
export class OrganizationSubscriptionInactiveComponent {

    public constructor(private readonly cache: InMemoryCacheService) {}

    public onSignOut(): void {
        this.cache.logout();
    }
}
